import React from 'react';

import Chip from '@mui/material/Chip';

import { SecurityCheckStatus, SecurityCheckStatusLabel } from 'stores/SecurityCheckStoreAdapter';

const SecurityCheckStatusColor: Record<SecurityCheckStatus, 'default' | 'warning' | 'success'> = {
  NOT_STARTED: 'default',
  IN_PROGRESS: 'warning',
  COMPLETED: 'success',
};

type Props = {
  status: SecurityCheckStatus;
  size?: 'small' | 'medium';
  onClick?: () => void;
};

/**
 * セキュリティチェックステータス専用 Chip コンポーネント。
 * ステータスに応じたラベルと色を SecurityCheckStatusLabel 定数から取得して表示する。
 */
const SecurityCheckStatusLabelChip: React.FC<Props> = ({ status, size = 'small', onClick }) => {
  return (
    <Chip
      label={SecurityCheckStatusLabel[status]}
      size={size}
      color={SecurityCheckStatusColor[status]}
      onClick={onClick}
      sx={{
        cursor: onClick ? 'pointer' : 'default',
        ...(size === 'small' && { height: 20, fontSize: '0.7rem' }),
      }}
    />
  );
};

export default SecurityCheckStatusLabelChip;
